'use strict';

function getBreakpoints(breakpoints) {
  var className = {};
  for (var size in breakpoints) {
    if (breakpoints.hasOwnProperty(size)) {
      className['col-' + size + '-' + breakpoints[size]] = true;
    }
  }
  return className;
}

module.exports = getBreakpoints;


/*****************
 ** WEBPACK FOOTER
 ** ./~/uvdom-bootstrap/lib/getBreakpoints.js
 ** module id = 506
 ** module chunks = 0
 **/